mutation PushDocuments($orderId: ID!) {
  pushDocuments(input: { orderId: $orderId }) {
    order {
      id
    }
    errors
  }
}
